// librairies
import React, { useReducer, createContext } from 'react';
import update from 'immutability-helper';

// inital state
const initialState = {
    showMenu: false,
};

// reducers responding to actions
const reducer = (state, action) => {
    switch(action.type) {
        // show menu
        case 'SHOW_MENU':
            return update(state, {
                showMenu: {$set: true}
            });
        case 'HIDE_MENU':
            return update(state, {
                showMenu: {$set: false}
            });
        default:
            return state;
    }
}

// create context
export const MobileMenuContext = createContext(initialState);

// create provider
export const MobileMenuProvider = props => {
    const [stateApp, dispatchApp] = useReducer(reducer, initialState);
  
    return (
        <MobileMenuContext.Provider displayName="MobileMenuContext" value={[stateApp, dispatchApp]}>
            {props.children}
        </MobileMenuContext.Provider>
    );
};